import { render, staticRenderFns } from "./sendReview.vue?vue&type=template&id=1b744db6&scoped=true"
import script from "./sendReview.vue?vue&type=script&lang=js"
export * from "./sendReview.vue?vue&type=script&lang=js"
import style0 from "./sendReview.vue?vue&type=style&index=0&id=1b744db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b744db6",
  null
  
)

export default component.exports